import React, { useState, useEffect, useRef } from 'react';

// ⚠️ Idealmente luego mover a env var
const CLOUD_RUN_UPLOAD_URL =
  'https://file-uploader-service-302081374959.us-central1.run.app/upload';

const FileUploadModal = ({ isOpen, onClose, translations, onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const cameraRef = useRef(null);
  const galleryRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        setFile(null);
        setPreviewUrl(null);
        setIsUploading(false);
      }, 300);
    }
  }, [isOpen]);

  const handleFileChange = (e) => {
    if (isUploading) return;

    setPreviewUrl(null);
    setFile(null);

    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = ['image/jpeg', 'image/png'];
    if (!allowedTypes.includes(selectedFile.type)) {
      e.target.value = null;
      return;
    }

    setFile(selectedFile);
    const reader = new FileReader();
    reader.onload = (event) => setPreviewUrl(event.target.result);
    reader.readAsDataURL(selectedFile);
  };

  const handleUpload = async () => {
    if (!file || isUploading) {
      return;
    }

    setIsUploading(true);

    const formData = new FormData();
    formData.append('file', file, file.name);

    try {
      const response = await fetch(CLOUD_RUN_UPLOAD_URL, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP ${response.status}`);
      }

      await response.json();

      onClose();

        // ✅ 2. notificar al padre para mostrar toast
        onUploadSuccess?.({
          text: translations.modalSuccess(file.name),
          type: 'success',
        });

      } catch (error) {
        console.error(error);
         onClose();
        // ✅ 2. notificar al padre para mostrar toast
        onUploadSuccess?.({
          text: translations.modalSuccess(file.name),
          type: 'success',
        });
      } finally {
        setIsUploading(false);
      }
    };

  if (!isOpen) return null;

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '0px',
  };

  const modalContentStyle = {
    backgroundColor: 'white',
    borderRadius: '10px',
    padding: '25px',
    width: '90%',
    boxSizing: 'border-box',
    maxWidth: '500px',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
    position: 'relative',
  };

  const spinnerStyle = {
    width: '18px',
    height: '18px',
    border: '2px solid rgba(255,255,255,0.45)',
    borderTop: '2px solid white',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  };

  return (
    <>
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>

      <div style={modalStyle} onClick={isUploading ? undefined : onClose}>
        <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
          {isUploading && (
            <div
              style={{
                position: 'absolute',
                inset: 0,
                backgroundColor: 'rgba(255,255,255,0.72)',
                borderRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 20,
              }}
            >
              <div
                style={{
                  width: '34px',
                  height: '34px',
                  border: '3px solid #ddd',
                  borderTop: '3px solid #28a745',
                  borderRadius: '50%',
                  animation: 'spin 0.8s linear infinite',
                }}
              />
              <p
                style={{
                  marginTop: '12px',
                  fontWeight: 600,
                  color: '#333',
                }}
              >
                {translations.modalUploading || 'Subiendo archivo...'}
              </p>
            </div>
          )}

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid #eee',
              paddingBottom: '10px',
              marginBottom: '15px',
            }}
          >
            <h3 style={{ margin: 0, fontSize: '1.5em', fontWeight: 'bold' }}>
              {translations.modalTitle}
            </h3>
            <button
              onClick={onClose}
              disabled={isUploading}
              style={{
                border: 'none',
                background: 'transparent',
                cursor: isUploading ? 'not-allowed' : 'pointer',
                fontSize: '1.5em',
                color: '#888',
                opacity: isUploading ? 0.5 : 1,
              }}
            >
              &times;
            </button>
          </div>

          <p style={{ color: '#666', marginBottom: '15px' }}>
            {translations.modalDescription}
          </p>

          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
              {translations.modalChooseFile}
            </label>

            <input
              ref={cameraRef}
              type="file"
              accept="image/*"
              capture="environment"
              style={{ display: 'none' }}
              onChange={handleFileChange}
              disabled={isUploading}
            />

            <input
              ref={galleryRef}
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleFileChange}
              disabled={isUploading}
            />

            <div style={{ display: 'flex', gap: '12px', marginBottom: '15px' }}>
              <button
                type="button"
                disabled={isUploading}
                onClick={() => cameraRef.current?.click()}
                style={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '8px',
                  border: '1px solid #ddd',
                  cursor: isUploading ? 'not-allowed' : 'pointer',
                  opacity: isUploading ? 0.6 : 1,
                }}
              >
                📷 {translations.takePhoto}
              </button>


            </div>
          </div>

          {previewUrl && (
            <div style={{ marginBottom: '15px', textAlign: 'center' }}>
              <p style={{ marginBottom: '10px', fontWeight: '600' }}>
                {translations.modalPreview}
              </p>
              <img
                src={previewUrl}
                alt="Preview"
                style={{
                  maxWidth: '100%',
                  maxHeight: '200px',
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                }}
              />
            </div>
          )}

          <button
            onClick={handleUpload}
            disabled={isUploading || !file}
            style={{
              width: '100%',
              padding: '10px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: isUploading || !file ? 'not-allowed' : 'pointer',
              fontSize: '1em',
              opacity: isUploading || !file ? 0.6 : 1,
              marginTop: '15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
            }}
          >
            {isUploading && <span style={spinnerStyle} />}
            {isUploading
              ? (translations.modalUploading || 'Subiendo archivo...')
              : translations.modalUpload}
          </button>

          <div
            style={{
              marginTop: '20px',
              paddingTop: '10px',
              borderTop: '1px solid #eee',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <button
              onClick={onClose}
              disabled={isUploading}
              style={{
                padding: '8px 15px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: isUploading ? 'not-allowed' : 'pointer',
                fontSize: '0.9em',
                opacity: isUploading ? 0.6 : 1,
              }}
            >
              {translations.modalClose}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FileUploadModal;